<template>
    <Fragment>
        <h2 class="m-3">{{ $t("config_manag_title") }}</h2>

        <div v-if="auth.isLogged">
            <!-- By Project -->
            <div id="accordion" class="mt-2 text-left">
                <div
                    class="card mb-3"
                    v-for="(project, key, index) in app.configs.list"
                    :key="index"
                >
                    <div
                        class="card-header d-flex flex-row"
                        :id="'project_' + index"
                    >
                        <a
                            href="javascript:void(0)"
                            style="text-decoration: underline"
                            v-if="project.id"
                            class="mr-auto"
                            @click="viewProject(project.id)"
                        >
                            {{ project.label }}
                        </a>
                        <span v-if="!project.id">{{
                            $t("projects_no_project")
                        }}</span>
                    </div>

                    <div id="collapseOne" class="collapse show">
                        <div class="card-body">
                            <configurations-component
                                :configurations="project.configurations"
                            >
                            </configurations-component>
                        </div>
                    </div>
                </div>
            </div>

            <!-- GENERAL -->
            <div>
                <!-- boton volver -->
                <button
                    type="button"
                    class="btn btn-dark text-center btn_return_width"
                    @click="
                        app.navigateToStageAsync(app.currentConfiguration.stage)
                    "
                >
                    <!-- <i class="fas fa-plus mr-2"></i> -->
                    {{ $t("modify_configuration_btn") }}
                </button>
            </div>
        </div>

        <div v-else>
            <!-- boton login -->
            <div @click="app.auth.login()" class="mb-4 text-center">
                <button class="btn btn-dark loginButton">
                    {{ $t("register_login") }}
                </button>
            </div>

            <!-- boton volver -->
            <button
                type="button"
                class="
                    btn btn-outline-secondary
                    my-5
                    text-center
                    btn_return_width
                "
                @click="
                    app.navigateToStageAsync(app.currentConfiguration.stage)
                "
            >
                <!-- <i class="fas fa-plus mr-2"></i> -->
                {{ $t("modify_configuration_btn") }}
            </button>
        </div>

        <!-- MODAL VIEW PROJECT -->
        <div
            id="viewProjectModal"
            ref="viewProjectModal"
            class="modal fade viewProjectModal"
            tabindex="-1"
            role="dialog"
        >
            <div
                class="
                    modal-dialog
                    modal-dialog-centered
                    modal-dialog-scrollable
                    modal-xl
                "
                style="min-width: 80%"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">{{ $t("project") }}</div>
                    <div class="modal-body scrollable">
                        <project-component
                            ref="viewProjectComponent"
                            :project="selectedProject"
                        ></project-component>
                    </div>
                    <div class="modal-footer">
                        <project-actions-component
                            ref="viewProjectActionsComponent"
                            :selectionActions="true"
                            :closeAction="true"
                            :project="selectedProject"
                        ></project-actions-component>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
</template>

<style scoped lang="scss">
.myConfigsMaxWidth {
    max-width: 1200px;
}

.btn_return_width {
    width: 200px;
}

.downloadBOMIcon {
    height: 40px;
    width: auto;
}
i {
    cursor: pointer;
}
</style>



<script>
import { app } from "../../application.js";
import jQuery from "jquery";
import { Fragment } from "vue-fragment";
import savedConfigDetailsComponent from "./savedConfigDetails.vue";
import projectComponent from "./project.vue"
import projectActionsComponent from "./projectActions.vue"
import configurationsComponent from "./configurations.vue"

export default {
    name: "myConfigs",

    data() {
        return {
            app: app,
            auth: app.auth,
            configurations: [],
            modalTitel: "",
            modalDate: "",
            currentSelectedConfigurationID: "",
            editingMode: false,
            loadedConfigs: false,
            selectionMode: false,
            selectionModeEnabled: false,
            count: 1,
            selectedProject: {
                configurations: []
            },
            selectedConfig: {

            }
        };
    },

    components: {
        Fragment,
        savedConfigDetailsComponent,
        configurationsComponent,
        projectComponent, projectActionsComponent
    },

    async created() {
        this.editingMode = false;
        // this.app.userIsInsideMyConfigs = true;
        await this.refresh();
    },
    destroyed() {
        // this.app.userIsInsideMyConfigs = false;
    },
    watch: {
        async 'editingMode'(newValue) {
            if (newValue == true) {
                // refrescar projectes
                await this.app.projects.refresh();
            }
        },
        async 'auth.isLogged'(newValue) {
            await this.refresh();
        },
        async 'app.projects.list'(newValue) {
            // forces checkbox refresh
            await this.refresh();
            this.count++;
        },
        'app.configs.list'(newValue) {
            // forces checkbox refresh
            this.count++;
        }
    },
    methods: {
        downloadExcel: async function (configurationId) {
            if (this.userIsLoggedIn) {
                await this.app.API.downloadById("xlsx", configurationId);
            }
        },
        downloadPdf: async function (configurationId) {
            if (this.userIsLoggedIn) {
                await this.app.API.downloadById("pdf", configurationId);
            }
        },
        downloadExcelFromModal: async function () {
            if (this.userIsLoggedIn) {
                await this.app.API.downloadById(
                    "xlsx",
                    this.currentSelectedConfigurationID
                );
            }
        },

        downloadPdfFromModal: async function () {
            if (this.userIsLoggedIn) {
                await this.app.API.downloadById(
                    "pdf",
                    this.currentSelectedConfigurationID
                );
            }
        },
        viewProject: async function (projectId) {
            if (!projectId) return

            // Load Project
            this.app.configs.selectionMode = false
            this.selectedProject = await this.app.API.getProject(projectId, true)

            // Opens modal
            jQuery("#viewProjectModal").modal("show");
        },
        viewConfig: async function (configurationId) {
            // Load Config
            this.app.configs.selectionMode = false
            this.selectedConfig = await this.app.API.getConfig(configurationId)

            // Opens modal
            jQuery("#viewConfigModal").modal("show");

            return
            var config = await this.app.API.getConfig(configurationId);

            this.currentSelectedConfigurationID = configurationId;

            this.$refs["configDetailComp"].savedConfig = config.data;
            this.modalTitel = config.label;
            this.modalDate = config.updated_at_formatted;

            jQuery("#myconfigsDetailModal").modal("show");
        },
        editConfig: function (configuration, element) {
            //Unex.log("Editing configuration: " + configuration.id);
            this.editingMode = true;
            this.$set(configuration, "isEditing", true);

            // Focus input
            this.$nextTick(() => {
                let input = jQuery(event.target)
                    .parent()
                    .parent()
                    .find("input");
                input.focus();
            });
        },
        saveConfig: async function (configuration) {
            try {
                await this.app.API.saveConfig(configuration);
                this.editingMode = false;

                await this.refresh()

            } catch (e) {

                console.warn(e);
            }

            // TODO: save config name
            this.$set(configuration, "isEditing", false);
        },
        deleteConfig: async function (configurationId) {
            let self = this;

            let infoModal = {
                modalToShow: "warnPageLeaveModal",
                title: this.app.translate("config_manag_delete_title"),
                message: this.app.translate("config_manag_delete_confirm"),
                html_message: "",
                showConfirmationButton: true,
                showCancelButton: true,
                textConfirmationButton: self.app.translate(
                    "default_text_acceptbutton"
                ),
                textCancelButton: self.app.translate(
                    "default_text_cancelbutton"
                ),
            };

            //ES6 object destructuring object resolved from promise:
            self.app
                .showModal(infoModal)
                .then(async ({ userAction, paramResult }) => {
                    if (userAction === "modal_rejected") {
                    } else if (userAction === "modal_confirmed") {
                        await this.app.API.deleteConfig(configurationId);
                        this.refresh();
                    }
                });
        },
        selectEntireProject: function (projectId) {
            this.app.configs.selectEntireProject(projectId)
            this.count++;
        },
        deselectEntireProject: function (projectId) {
            this.app.configs.deselectEntireProject(projectId)
            this.count++;
        },
        refresh: async function () {
            if (!this.auth.isLogged) return;
            if (this.editingMode) return; // Evitar bucles
            var self = this;

            self.app.showSpinner();
            try {
                await app.configs.refresh()
            } catch (error) {
                // TODO: gestionar
                Unex.error(error)
            }
            // self.loadedConfigs = true;
            self.app.hideSpinner();

        },
    },
    computed: {
        userIsLoggedIn: function () {
            return app.auth.isLogged;
        },
    },
};
</script>




